module.exports = __webpack_public_path__ + "img/Pavilion Touching Metal.9f712d1d.png";